/* Cobra Coldres — mantém o link "Comprar pelo WhatsApp" com a CONFIGURAÇÃO atual.
   Mensagem ESTRUTURADA e SEM LINK (a URL gerava card de prévia que atrapalhava o operador
   no Chatwoot): abertura + "Produto: ..." + uma linha por opção. Pula opções ocultas
   (ex.: red dot em revólver).

   A leitura da configuração mora em cobra-variante-config.js (compartilhada com o chat do
   site desde 2026-08-19) — o snippet carrega os dois arquivos, nesta ordem.

   🐛 BUG CORRIGIDO EM 2026-08-19 (existia desde sempre, achado ao testar o canal):
   o script guardava a referência do <a> UMA VEZ, no carregamento. Só que o Dawn
   RE-RENDERIZA o bloco de compra a cada troca de variante — o elemento guardado vira
   fantasma (fora do documento) e o botão que o cliente vê continua com a mensagem da
   configuração INICIAL. Na prática: quem escolhia Canhoto e clicava mandava "Mão: Destro".
   Em coldre isso é erro de pedido, não detalhe.
   Correção: NUNCA guardar o elemento. Procurar de novo a cada atualização, e reprocessar
   também DEPOIS da troca (o Dawn leva ~500ms para trocar o bloco, então uma passada só,
   no evento, pega o DOM velho). */
(function () {
  function configLinhas() {
    if (!window.cobraVarianteConfig) return [];
    return window.cobraVarianteConfig().map(function (o) {
      return (o.nome ? o.nome + ': ' : '') + o.valor;
    });
  }

  function atualiza() {
    /* busca fresca: o nó de antes pode já ter sido substituído pelo Dawn */
    var links = document.querySelectorAll('[data-wa-comprar]');
    for (var i = 0; i < links.length; i++) {
      var link = links[i];
      var num = link.getAttribute('data-wa-num') || '';
      var base = link.getAttribute('data-wa-base') || '';
      var title = link.getAttribute('data-wa-title') || '';
      var linhas = [base, '', 'Produto: ' + title].concat(configLinhas());
      link.setAttribute('href', 'https://wa.me/' + num + '?text=' + encodeURIComponent(linhas.join('\n')));
    }
  }

  /* o evento chega ANTES de o Dawn trocar o bloco; as passadas seguintes pegam o nó novo */
  function atualizaEmSeguida() {
    window.requestAnimationFrame(atualiza);
    window.setTimeout(atualiza, 350);
    window.setTimeout(atualiza, 900);
  }

  atualiza();
  document.addEventListener('change', function (e) {
    if (e.target.matches && e.target.matches('variant-selects input, variant-selects select')) {
      atualizaEmSeguida();
    }
  });

  /* rede de segurança: se o bloco de compra for trocado por qualquer outro caminho (o Dawn
     tem mais de um), o observador devolve a mensagem certa sem depender do evento. */
  if (window.MutationObserver) {
    var alvo = document.querySelector('product-form') || document.body;
    new MutationObserver(function () { window.requestAnimationFrame(atualiza); })
      .observe(alvo, { childList: true, subtree: true });
  }
})();
